"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionByCid = exports.getValueByCid = exports.inRegion = void 0;
var constant_1 = require("./constant");
/**
 * 判断当前环境是否在指定地区内
 * @param {Cid} cids
 * @returns
 */
var inRegion = function (cids, targetCid) {
    if (targetCid === void 0) { targetCid = constant_1.currentCid; }
    cids = Array.isArray(cids) ? cids : [cids];
    return cids.some(function (cid) { return cid === targetCid; });
};
exports.inRegion = inRegion;
/**
 * 根据cid,返回函数执行后不同结果
 * @param args
 * @param params
 */
function getValueByCid(arg, params) {
    var target;
    target = arg.find(function (item) {
        var cid = item.cid;
        return exports.inRegion(cid);
    });
    if (!target && params && params.defaultCid) {
        target = arg.find(function (item) { return item.cid.indexOf(params.defaultCid) !== -1; });
    }
    var result = target && target.value;
    return typeof result === 'function'
        ? result(params === null || params === void 0 ? void 0 : params.initialValue)
        : result;
}
exports.getValueByCid = getValueByCid;
/**
 * 根据 cid 的值得到 key, 例如：co.id => id
 * @param cid
 */
function getRegionByCid(cid) {
    if (!cid)
        return '';
    var returnKey = '';
    Object.entries(constant_1.CidMap).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (cid === value)
            returnKey = key;
    });
    return returnKey;
}
exports.getRegionByCid = getRegionByCid;
